export default __webpack_public_path__ + "images/YX.b849031.png";